// cleanup_convert_to_typescript_file_VIEW_RECURRING_TRANSFERS

import { createUseStyles } from '@glu/theming';

const styles = ({ palette, spacing: { unit } }) => ({
  modalDialog: {
    textAlign: 'center',
    '& .modal-header': {
      textTransform: 'uppercase'
    },
    '& [class^="iconWrapper"]': {
      '& [class^="icon-info-circle"]:first-child': {
        display: 'none'
      }
    },
    '& [class^="icon-use-funds-next"]': {
      display: 'inline',
      fill: palette.grey.G400,
      width: unit * 6,
      height: unit * 6,
      marginBottom: unit * 3
    },
    '& [class^="actions"]': {
      display: 'flex',
      justifyContent: 'center'
    }
  }
});

export default createUseStyles(styles);
